import React, { useEffect, useState } from "react";
import axios from "axios";
import "./ProductsSection.css";

const ProductsSection = () => {
  const [products, setProducts] = useState([]);
  const [modalProduct, setModalProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const [showCountdown, setShowCountdown] = useState(false);

  const openModal = (product) => setModalProduct(product);
  const closeModal = () => setModalProduct(null);

  // Function to fetch products
  const fetchProducts = async () => {
    try {
      const res = await axios.get(
        "https://vangal-backend.onrender.com/api/products"
      );
      setProducts(res.data);
    } catch (err) {
      console.error("Failed to fetch products:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const wakeBackend = async () => {
      try {
        // Ping backend root to check if it's awake
        await axios.get("https://vangal-backend.onrender.com/", { timeout: 3000 });
        // Backend is awake → fetch products immediately
        fetchProducts();
      } catch (err) {
        // Backend asleep → show countdown
        setShowCountdown(true);
      }
    };

    wakeBackend();
  }, []);

  // Countdown effect (only if backend was asleep)
  useEffect(() => {
    if (!showCountdown) return; // only run if countdown is needed

    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      // Countdown finished → fetch products
      fetchProducts();
      setShowCountdown(false);
    }
  }, [countdown, showCountdown]);

  const renderCard = (product) => (
    <div key={product.id} className="vangal-product-card">
      <img src={product.img} alt={product.title} />
      <h3>{product.title}</h3>
      <p>{product.description.split(".")[0]}.</p>
      <button className="explore-btn" onClick={() => openModal(product)}>
        About Product
      </button>
    </div>
  );

  return (
    <section className="vangal-products-section">
      <h2 className="vangal-products-title anim anim-top">OUR PRODUCTS</h2>

      {loading ? (
        showCountdown ? (
          <div className="vangal-loading">
            <p>
              Our backend is waking up. Loading products in{" "}
              <strong>{countdown}</strong> seconds...
            </p>
          </div>
        ) : (
          <div className="vangal-loading">
            <p>Loading products...</p>
          </div>
        )
      ) : (
        <div className="vangal-products-row">{products.map(renderCard)}</div>
      )}

      {modalProduct && (
        <div className="vangal-modal-overlay" onClick={closeModal}>
          <div
            className="vangal-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="vangal-modal-close" onClick={closeModal}>
              &times;
            </button>
            <img src={modalProduct.img} alt={modalProduct.title} />
            <h3>{modalProduct.title}</h3>
            <p>{modalProduct.description}</p>
            <p>
              <strong>Package Sizes:</strong> {modalProduct.packageSize.join(", ")}
            </p>
            <p>
              <strong>Protein:</strong> {modalProduct.protein}
            </p>
            <ul>
              {modalProduct.benefits.map((b, i) => (
                <li key={i}>{b}</li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </section>
  );
};

export default ProductsSection;
